// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MODAL OVERLAY
   ============================================ */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* ============================================
   MODAL CONTENT
   ============================================ */
.student-import-modal {
  background: white;
  border-radius: 12px;
  width: 95%;
  max-width: 1100px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s;
}

@keyframes slideIn {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* ============================================
   HEADER
   ============================================ */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #1e3a5f, #2563eb);
  border-radius: 12px 12px 0 0;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.4rem;
  color: white;
}

.btn-close {
  background: rgba(255,255,255,0.2);
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-close:hover {
  background: rgba(255,255,255,0.3);
}

/* ============================================
   BARRE NAVIGATION NIVEAUX
   ============================================ */
.level-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border-bottom: 1px solid #bfdbfe;
}

.level-indicator {
  font-weight: 700;
  font-size: 1.1rem;
  color: #1e40af;
  display: flex;
  align-items: center;
  gap: 8px;
}

.level-count {
  font-weight: 500;
  font-size: 0.95rem;
  color: #3b82f6;
}

.level-position {
  font-weight: 400;
  font-size: 0.85rem;
  color: #64748b;
}

.btn-nav {
  padding: 8px 16px;
  background: white;
  border: 2px solid #3b82f6;
  color: #3b82f6;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.btn-nav:hover:not(:disabled) {
  background: #3b82f6;
  color: white;
}

.btn-nav:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: #94a3b8;
  color: #94a3b8;
}

/* ============================================
   BODY
   ============================================ */
.modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
}

/* ============================================
   LOADING
   ============================================ */
.loading-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  color: #64748b;
}

.loading-spinner {
  font-size: 2.5rem;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* ============================================
   VUE LISTE ÉTUDIANTS
   ============================================ */
.list-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.students-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 400px;
  overflow-y: auto;
  padding: 4px;
}

.student-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.student-item:hover {
  border-color: #3b82f6;
  background: #eff6ff;
}

.student-item.selected {
  border-color: #22c55e;
  background: #f0fdf4;
}

.student-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.student-name {
  font-weight: 600;
  color: #1f2937;
}

.student-details {
  display: flex;
  gap: 12px;
  font-size: 0.85rem;
}

.student-ine {
  color: #6b7280;
}

.student-groupe {
  color: #6b7280;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 4px;
}

.student-check {
  font-size: 1.2rem;
}

/* Sélection tout */
.select-all-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
  color: #64748b;
}

.select-all-item:hover {
  border-color: #3b82f6;
  background: #eff6ff;
  color: #3b82f6;
}

.select-all-item.selected {
  border-color: #22c55e;
  border-style: solid;
  background: #f0fdf4;
  color: #16a34a;
}

/* ============================================
   SECTION MODÈLES
   ============================================ */
.modeles-section {
  background: #fefce8;
  border: 1px solid #fde047;
  border-radius: 10px;
  margin-bottom: 16px;
  overflow: hidden;
}

.modeles-section.collapsed .modeles-content {
  display: none;
}

.modeles-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 600;
  color: #854d0e;
  background: #fef9c3;
}

.modeles-header:hover {
  background: #fef08a;
}

.toggle-icon {
  font-size: 0.8rem;
}

.modeles-content {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.modele-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: white;
  border: 1px solid #fde68a;
  border-radius: 8px;
}

.modele-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.modele-name {
  font-weight: 500;
  color: #1f2937;
}

.modele-count {
  font-size: 0.85rem;
  color: #6b7280;
}

.modele-actions {
  display: flex;
  gap: 8px;
}

.save-modele-btn {
  margin-bottom: 16px;
}

.save-modele-form {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 16px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
}

.save-modele-form input {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
}

/* ============================================
   ZONE UPLOAD
   ============================================ */
.upload-zone {
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #f8fafc;
  margin-bottom: 16px;
}

.upload-zone:hover {
  border-color: #3b82f6;
  background: #eff6ff;
}

.upload-zone.drag-active {
  border-color: #22c55e;
  background: #f0fdf4;
  transform: scale(1.02);
}

.upload-zone.has-file {
  border-color: #22c55e;
  border-style: solid;
  background: #f0fdf4;
}

.upload-placeholder {
  color: #64748b;
  font-size: 1.1rem;
}

.upload-hint {
  font-size: 0.85rem;
  color: #94a3b8;
  display: block;
  margin-top: 8px;
}

.upload-status {
  font-size: 1rem;
  color: #64748b;
}

.upload-status.success {
  color: #16a34a;
  font-weight: 500;
}

/* ============================================
   ENCODAGE
   ============================================ */
.encoding-selector {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.encoding-selector label {
  font-weight: 500;
  color: #374151;
}

.encoding-selector select {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.9rem;
}

/* ============================================
   GROUPES CONTAINER
   ============================================ */
.analysis-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.groups-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.groups-section,
.preview-section {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px;
}

.groups-section h3,
.preview-section h3,
.affected-section h3 {
  margin: 0 0 12px 0;
  font-size: 1rem;
  color: #374151;
}

/* ============================================
   LISTE GROUPES
   ============================================ */
.groups-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
}

.group-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.group-item:hover {
  border-color: #3b82f6;
  background: #eff6ff;
}

.group-item.selected {
  border-color: #22c55e;
  background: #f0fdf4;
}

.group-item.affected {
  background: #f1f5f9;
  border-color: #94a3b8;
  cursor: default;
}

.group-name {
  font-weight: 600;
  color: #1f2937;
  flex: 1 1;
}

.group-count {
  color: #6b7280;
  font-size: 0.9rem;
}

.group-check {
  font-size: 1.1rem;
}

.group-target {
  color: #6b7280;
  font-size: 0.85rem;
  font-style: italic;
}

.group-lock {
  cursor: pointer;
  font-size: 1.1rem;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}

.group-lock:hover {
  background: #fee2e2;
}

/* ============================================
   PRÉVISUALISATION MINI
   ============================================ */
.preview-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 180px;
  overflow-y: auto;
  margin-bottom: 12px;
}

.preview-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

.preview-stats {
  text-align: center;
  color: #6b7280;
  font-size: 0.9rem;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
}

.empty-message {
  color: #94a3b8;
  font-style: italic;
  text-align: center;
  padding: 20px;
}

/* ============================================
   SECTION DÉJÀ AFFECTÉS
   ============================================ */
.affected-section {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 16px;
}

.affected-section .groups-list {
  max-height: 120px;
}

/* ============================================
   VUE PRÉVISUALISATION COMPLÈTE
   ============================================ */
.preview-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Barre de recherche */
.search-bar {
  margin-bottom: 8px;
}

.search-bar input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.95rem;
}

.search-bar input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Table étudiants */
.full-list {
  max-height: 350px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.students-table {
  width: 100%;
  border-collapse: collapse;
}

.students-table th {
  position: sticky;
  top: 0;
  background: #f9fafb;
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
}

.students-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
}

.students-table tbody tr:hover {
  background: #f9fafb;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}

.btn-icon.btn-danger:hover {
  background: #fee2e2;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 12px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}

.pagination button {
  padding: 6px 14px;
  border: 1px solid #d1d5db;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.pagination button:hover:not(:disabled) {
  background: #f3f4f6;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Options import */
.import-options {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 8px;
}

.option-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.radio-label,
.checkbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

/* ============================================
   ALERTES
   ============================================ */
.alert {
  padding: 14px 18px;
  border-radius: 8px;
  margin-top: 12px;
}

.alert-error {
  background: #fef2f2;
  border: 1px solid #fca5a5;
  color: #991b1b;
}

.alert-success {
  background: #f0fdf4;
  border: 1px solid #86efac;
  color: #166534;
}

/* ============================================
   BOUTONS ACTIONS
   ============================================ */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn-small {
  padding: 6px 12px;
  font-size: 0.85rem;
}

.btn-primary {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  transform: translateY(-1px);
}

.btn-secondary {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}

.btn-secondary:hover {
  background: #e5e7eb;
}

.btn-success {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  color: white;
}

.btn-success:hover:not(:disabled) {
  background: linear-gradient(135deg, #16a34a, #15803d);
}

.btn-danger {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: linear-gradient(135deg, #dc2626, #b91c1c);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* ============================================
   MODAL CONFIRMATION
   ============================================ */
.confirm-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.confirm-dialog {
  background: white;
  padding: 24px;
  border-radius: 12px;
  max-width: 400px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.confirm-dialog h3 {
  margin: 0 0 16px 0;
  color: #1f2937;
}

.confirm-dialog p {
  color: #4b5563;
  margin-bottom: 20px;
  line-height: 1.5;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 768px) {
  .groups-container {
    grid-template-columns: 1fr;
  }
  
  .level-navigation {
    flex-direction: column;
    gap: 10px;
  }
  
  .modal-actions {
    flex-direction: column;
  }
  
  .modal-actions .btn {
    width: 100%;
  }
}

/* ============================================
   CORRECTIONS AFFICHAGE ÉTUDIANTS
   ============================================ */

/* Ligne étudiant sur une seule ligne */
.student-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  padding: 12px 16px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.student-item .student-name {
  flex: 1 1;
  font-weight: 500;
  color: #1f2937;
  text-align: left;
}

.student-item .student-groupe {
  min-width: 100px;
  font-size: 0.9rem;
  color: #6b7280;
  background: #f1f5f9;
  padding: 4px 10px;
  border-radius: 4px;
  text-align: left;
}

.student-item .student-check {
  font-size: 1.1rem;
  margin-left: auto;
}

/* Info sélection */
.selection-info {
  text-align: center;
  padding: 8px;
  background: #eff6ff;
  border-radius: 6px;
  color: #1e40af;
  font-weight: 500;
  margin-top: 8px;
}

/* Preview item aussi sur une ligne */
.preview-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  padding: 10px 14px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

.preview-item .student-name {
  flex: 1 1;
  text-align: left;
}

.preview-item .student-groupe {
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/StudentImportModal.css"],"names":[],"mappings":"AAAA;;iDAEiD;AACjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;;iDAEiD;AACjD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;iDAEiD;AACjD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;iDAEiD;AACjD;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;iDAEiD;;AAEjD,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* ============================================\n   MODAL OVERLAY\n   ============================================ */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.2s;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* ============================================\n   MODAL CONTENT\n   ============================================ */\n.student-import-modal {\n  background: white;\n  border-radius: 12px;\n  width: 95%;\n  max-width: 1100px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* ============================================\n   HEADER\n   ============================================ */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e5e7eb;\n  background: linear-gradient(135deg, #1e3a5f, #2563eb);\n  border-radius: 12px 12px 0 0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.4rem;\n  color: white;\n}\n\n.btn-close {\n  background: rgba(255,255,255,0.2);\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: white;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.btn-close:hover {\n  background: rgba(255,255,255,0.3);\n}\n\n/* ============================================\n   BARRE NAVIGATION NIVEAUX\n   ============================================ */\n.level-navigation {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #eff6ff, #dbeafe);\n  border-bottom: 1px solid #bfdbfe;\n}\n\n.level-indicator {\n  font-weight: 700;\n  font-size: 1.1rem;\n  color: #1e40af;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.level-count {\n  font-weight: 500;\n  font-size: 0.95rem;\n  color: #3b82f6;\n}\n\n.level-position {\n  font-weight: 400;\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.btn-nav {\n  padding: 8px 16px;\n  background: white;\n  border: 2px solid #3b82f6;\n  color: #3b82f6;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-weight: 500;\n}\n\n.btn-nav:hover:not(:disabled) {\n  background: #3b82f6;\n  color: white;\n}\n\n.btn-nav:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  border-color: #94a3b8;\n  color: #94a3b8;\n}\n\n/* ============================================\n   BODY\n   ============================================ */\n.modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n/* ============================================\n   LOADING\n   ============================================ */\n.loading-view {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px;\n  color: #64748b;\n}\n\n.loading-spinner {\n  font-size: 2.5rem;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* ============================================\n   VUE LISTE ÉTUDIANTS\n   ============================================ */\n.list-view {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.students-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 4px;\n}\n\n.student-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.student-item:hover {\n  border-color: #3b82f6;\n  background: #eff6ff;\n}\n\n.student-item.selected {\n  border-color: #22c55e;\n  background: #f0fdf4;\n}\n\n.student-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.student-name {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.student-details {\n  display: flex;\n  gap: 12px;\n  font-size: 0.85rem;\n}\n\n.student-ine {\n  color: #6b7280;\n}\n\n.student-groupe {\n  color: #6b7280;\n  background: #f1f5f9;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.student-check {\n  font-size: 1.2rem;\n}\n\n/* Sélection tout */\n.select-all-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 18px;\n  background: #f8fafc;\n  border: 2px dashed #cbd5e1;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.select-all-item:hover {\n  border-color: #3b82f6;\n  background: #eff6ff;\n  color: #3b82f6;\n}\n\n.select-all-item.selected {\n  border-color: #22c55e;\n  border-style: solid;\n  background: #f0fdf4;\n  color: #16a34a;\n}\n\n/* ============================================\n   SECTION MODÈLES\n   ============================================ */\n.modeles-section {\n  background: #fefce8;\n  border: 1px solid #fde047;\n  border-radius: 10px;\n  margin-bottom: 16px;\n  overflow: hidden;\n}\n\n.modeles-section.collapsed .modeles-content {\n  display: none;\n}\n\n.modeles-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  cursor: pointer;\n  font-weight: 600;\n  color: #854d0e;\n  background: #fef9c3;\n}\n\n.modeles-header:hover {\n  background: #fef08a;\n}\n\n.toggle-icon {\n  font-size: 0.8rem;\n}\n\n.modeles-content {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.modele-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: white;\n  border: 1px solid #fde68a;\n  border-radius: 8px;\n}\n\n.modele-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.modele-name {\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.modele-count {\n  font-size: 0.85rem;\n  color: #6b7280;\n}\n\n.modele-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.save-modele-btn {\n  margin-bottom: 16px;\n}\n\n.save-modele-form {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 16px;\n  padding: 12px;\n  background: #f8fafc;\n  border-radius: 8px;\n}\n\n.save-modele-form input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n}\n\n/* ============================================\n   ZONE UPLOAD\n   ============================================ */\n.upload-zone {\n  border: 2px dashed #cbd5e1;\n  border-radius: 12px;\n  padding: 40px 20px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s;\n  background: #f8fafc;\n  margin-bottom: 16px;\n}\n\n.upload-zone:hover {\n  border-color: #3b82f6;\n  background: #eff6ff;\n}\n\n.upload-zone.drag-active {\n  border-color: #22c55e;\n  background: #f0fdf4;\n  transform: scale(1.02);\n}\n\n.upload-zone.has-file {\n  border-color: #22c55e;\n  border-style: solid;\n  background: #f0fdf4;\n}\n\n.upload-placeholder {\n  color: #64748b;\n  font-size: 1.1rem;\n}\n\n.upload-hint {\n  font-size: 0.85rem;\n  color: #94a3b8;\n  display: block;\n  margin-top: 8px;\n}\n\n.upload-status {\n  font-size: 1rem;\n  color: #64748b;\n}\n\n.upload-status.success {\n  color: #16a34a;\n  font-weight: 500;\n}\n\n/* ============================================\n   ENCODAGE\n   ============================================ */\n.encoding-selector {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.encoding-selector label {\n  font-weight: 500;\n  color: #374151;\n}\n\n.encoding-selector select {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.9rem;\n}\n\n/* ============================================\n   GROUPES CONTAINER\n   ============================================ */\n.analysis-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.groups-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.groups-section,\n.preview-section {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.groups-section h3,\n.preview-section h3,\n.affected-section h3 {\n  margin: 0 0 12px 0;\n  font-size: 1rem;\n  color: #374151;\n}\n\n/* ============================================\n   LISTE GROUPES\n   ============================================ */\n.groups-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.group-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.group-item:hover {\n  border-color: #3b82f6;\n  background: #eff6ff;\n}\n\n.group-item.selected {\n  border-color: #22c55e;\n  background: #f0fdf4;\n}\n\n.group-item.affected {\n  background: #f1f5f9;\n  border-color: #94a3b8;\n  cursor: default;\n}\n\n.group-name {\n  font-weight: 600;\n  color: #1f2937;\n  flex: 1;\n}\n\n.group-count {\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n\n.group-check {\n  font-size: 1.1rem;\n}\n\n.group-target {\n  color: #6b7280;\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n.group-lock {\n  cursor: pointer;\n  font-size: 1.1rem;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.group-lock:hover {\n  background: #fee2e2;\n}\n\n/* ============================================\n   PRÉVISUALISATION MINI\n   ============================================ */\n.preview-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 180px;\n  overflow-y: auto;\n  margin-bottom: 12px;\n}\n\n.preview-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n}\n\n.preview-stats {\n  text-align: center;\n  color: #6b7280;\n  font-size: 0.9rem;\n  padding-top: 8px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.empty-message {\n  color: #94a3b8;\n  font-style: italic;\n  text-align: center;\n  padding: 20px;\n}\n\n/* ============================================\n   SECTION DÉJÀ AFFECTÉS\n   ============================================ */\n.affected-section {\n  background: #f1f5f9;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.affected-section .groups-list {\n  max-height: 120px;\n}\n\n/* ============================================\n   VUE PRÉVISUALISATION COMPLÈTE\n   ============================================ */\n.preview-view {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Barre de recherche */\n.search-bar {\n  margin-bottom: 8px;\n}\n\n.search-bar input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.95rem;\n}\n\n.search-bar input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Table étudiants */\n.full-list {\n  max-height: 350px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.students-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.students-table th {\n  position: sticky;\n  top: 0;\n  background: #f9fafb;\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.students-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.students-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.btn-icon {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.btn-icon.btn-danger:hover {\n  background: #fee2e2;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  padding: 12px;\n  background: #f9fafb;\n  border-top: 1px solid #e5e7eb;\n}\n\n.pagination button {\n  padding: 6px 14px;\n  border: 1px solid #d1d5db;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.pagination button:hover:not(:disabled) {\n  background: #f3f4f6;\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Options import */\n.import-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 16px;\n  background: #f9fafb;\n  border-radius: 8px;\n}\n\n.option-group {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.radio-label,\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n/* ============================================\n   ALERTES\n   ============================================ */\n.alert {\n  padding: 14px 18px;\n  border-radius: 8px;\n  margin-top: 12px;\n}\n\n.alert-error {\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  color: #991b1b;\n}\n\n.alert-success {\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  color: #166534;\n}\n\n/* ============================================\n   BOUTONS ACTIONS\n   ============================================ */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.btn-small {\n  padding: 6px 12px;\n  font-size: 0.85rem;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\n  transform: translateY(-1px);\n}\n\n.btn-secondary {\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.btn-secondary:hover {\n  background: #e5e7eb;\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #22c55e, #16a34a);\n  color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n  background: linear-gradient(135deg, #16a34a, #15803d);\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: linear-gradient(135deg, #dc2626, #b91c1c);\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ============================================\n   MODAL CONFIRMATION\n   ============================================ */\n.confirm-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n}\n\n.confirm-dialog {\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  max-width: 400px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.confirm-dialog h3 {\n  margin: 0 0 16px 0;\n  color: #1f2937;\n}\n\n.confirm-dialog p {\n  color: #4b5563;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n@media (max-width: 768px) {\n  .groups-container {\n    grid-template-columns: 1fr;\n  }\n  \n  .level-navigation {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .modal-actions {\n    flex-direction: column;\n  }\n  \n  .modal-actions .btn {\n    width: 100%;\n  }\n}\n\n/* ============================================\n   CORRECTIONS AFFICHAGE ÉTUDIANTS\n   ============================================ */\n\n/* Ligne étudiant sur une seule ligne */\n.student-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n  padding: 12px 16px;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.student-item .student-name {\n  flex: 1;\n  font-weight: 500;\n  color: #1f2937;\n  text-align: left;\n}\n\n.student-item .student-groupe {\n  min-width: 100px;\n  font-size: 0.9rem;\n  color: #6b7280;\n  background: #f1f5f9;\n  padding: 4px 10px;\n  border-radius: 4px;\n  text-align: left;\n}\n\n.student-item .student-check {\n  font-size: 1.1rem;\n  margin-left: auto;\n}\n\n/* Info sélection */\n.selection-info {\n  text-align: center;\n  padding: 8px;\n  background: #eff6ff;\n  border-radius: 6px;\n  color: #1e40af;\n  font-weight: 500;\n  margin-top: 8px;\n}\n\n/* Preview item aussi sur une ligne */\n.preview-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n  padding: 10px 14px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n}\n\n.preview-item .student-name {\n  flex: 1;\n  text-align: left;\n}\n\n.preview-item .student-groupe {\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
